<template>
    <div class="row">
        <div class="small-12 columns" :class="{ error: showMandatorLawformErrorText }">
            <label>
                Anrede
                <select v-model="formData.mandator_lawform">
                    <option
                        v-for="lawform in lawformSelectData"
                        :key="lawform.value"
                        :value="lawform.value"
                    >
                        {{lawform.text}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showMandatorLawformErrorText">
                {{ mandatorLawformErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMandatorPrenameErrorText }">
            <label>
                Vorname
                <input type="text" v-model="formData.mandator_prename"/>
            </label>
            <small class="error" v-if="showMandatorPrenameErrorText">
                {{ mandatorPrenameErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMandatorSurnameErrorText }">
            <label>
                Nachname
                <input type="text" v-model="formData.mandator_surname"/>
            </label>
            <small class="error" v-if="showMandatorSurnameErrorText">
                {{ mandatorSurnameErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMandatorMailErrorText }">
            <label>
                E-Mail Adresse (für die Antwort des Herstellers)
                <input type="text" v-model="formData.mandator_mail"/>
            </label>
            <small class="error" v-if="showMandatorMailErrorText">
                {{ mandatorMailErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showMandatorIbanErrorText }">
            <label>
                IBAN (für die Schadensersatzzahlung des Herstellers)
                <input type="text" v-model="formData.mandator_iban"/>
            </label>
            <small class="error" v-if="showMandatorIbanErrorText">
                {{ mandatorIbanErrorText }}
            </small>
        </div>
        <div class="small-12 columns" :class="{ error: showHasSecondMandatorErrorText }">
            <label>
                Möchten Sie einen weiteren Käufer hinzufügen?
                <select v-model="formData.has_second_mandator">
                    <option
                        v-for="selectValue in defaultSelectValues"
                        :key="selectValue.value"
                        :value="selectValue.value"
                    >
                        {{selectValue.title}}
                    </option>
                </select>
            </label>
            <small class="error" v-if="showHasSecondMandatorErrorText">
                {{ hasSecondMandatorErrorText }}
            </small>
        </div>
        <template v-if="showSecondMandatorSection">
            <div class="small-12 columns">
                <div class="sub-borrower-section">
                    <h4>Weiterer Käufer</h4>
                    <div :class="{ error: showSecondMandatorLawformErrorText }">
                        <label>
                            Anrede
                            <select v-model="formData.second_mandator_lawform">
                                <option
                                    v-for="lawform in lawformSelectData"
                                    :key="lawform.value"
                                    :value="lawform.value"
                                >
                                    {{lawform.text}}
                                </option>
                            </select>
                        </label>
                        <small class="error" v-if="showSecondMandatorLawformErrorText">
                            {{ secondMandatorLawformErrorText }}
                        </small>
                    </div>
                    <div :class="{ error: showSecondMandatorPrenameErrorText }">
                        <label>
                            Vorname
                            <input type="text" v-model="formData.second_mandator_prename"/>
                        </label>
                        <small class="error" v-if="showSecondMandatorPrenameErrorText">
                            {{ secondMandatorPrenameErrorText }}
                        </small>
                    </div>
                    <div :class="{ error: showSecondMandatorSurnameErrorText }">
                        <label>
                            Nachname
                            <input type="text" v-model="formData.second_mandator_surname"/>
                        </label>
                        <small class="error" v-if="showSecondMandatorSurnameErrorText">
                            {{ secondMandatorSurnameErrorText }}
                        </small>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import TypeHelper from '../../helper/TypeHelper';
import Validation from '../../helper/Validation';
import Lawforms from '../../constants/Lawforms';

export default {
    name: 'MandatorDataFormStep',
    props: {
        caseData: {
            type: Object,
            default: function()
            {
                return {
                    mandator_lawform:                       null,
                    mandator_prename:                       null,
                    mandator_surname:                       null,
                    mandator_mail:                          null,
                    mandator_iban:                          null,
                    second_mandator_lawform:                null,
                    second_mandator_prename:                null,
                    second_mandator_surname:                null,
                    manufacturer_id:                        null,
                    purchase_date:                          null,
                    emissions_type:                         null,
                    mileage_purchase:                       null,
                    mileage:                                null,
                    price:                                  null,
                    is_vehicle_sold:                        null,
                    was_new:                                null,
                    selected_compensation:                  null
                }
            }
        }
    },
    data: () => ({
        formData: {
            mandator_lawform:           null,
            mandator_prename:           null,
            mandator_surname:           null,
            mandator_mail:              null,
            mandator_iban:              null,
            has_second_mandator:        null,
            second_mandator_lawform:    null,
            second_mandator_prename:    null,
            second_mandator_surname:    null
        },
        validation: {
            isFormDirty: false,
            isMandatorLawformDirty: false,
            isMandatorPrenameDirty: false,
            isMandatorSurnameDirty: false,
            isMandatorMailDirty: false,
            isMandatorIbanDirty: false,
            isHasSecondMandatorDirty: false,
            isSecondMandatorLawformDirty: false,
            isSecondMandatorPrenameDirty: false,
            isSecondMandatorSurnameDirty: false
        },
        constants: {
            SELECT_VALUE_YES: {
                value: true,
                title: 'Ja'
            },
            SELECT_VALUE_FALSE: {
                value: false,
                title: 'Nein'
            }
        },
        lawformSelectData: [
            Lawforms.HERR,
            Lawforms.FRAU
        ]
    }),
    computed: {
        defaultSelectValues()
        {
            return [
                this.constants.SELECT_VALUE_YES,
                this.constants.SELECT_VALUE_FALSE
            ];
        },
        showSecondMandatorSection()
        {
            return this.formData.has_second_mandator === true;
        },
        showMandatorLawformErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorLawformDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorLawformErrorText);
        },
        showMandatorPrenameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorPrenameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorPrenameErrorText);
        },
        showMandatorSurnameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorSurnameDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorSurnameErrorText);
        },
        showMandatorMailErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorMailDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorMailErrorText);
        },
        showMandatorIbanErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isMandatorIbanDirty)
                && TypeHelper.isNotNullOrUndefined(this.mandatorIbanErrorText);
        },
        showHasSecondMandatorErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isHasSecondMandatorDirty)
                && TypeHelper.isNotNullOrUndefined(this.hasSecondMandatorErrorText);
        },
        showSecondMandatorLawformErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isSecondMandatorLawformDirty)
                && TypeHelper.isNotNullOrUndefined(this.secondMandatorLawformErrorText);
        },
        showSecondMandatorPrenameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isSecondMandatorPrenameDirty)
                && TypeHelper.isNotNullOrUndefined(this.secondMandatorPrenameErrorText);
        },
        showSecondMandatorSurnameErrorText()
        {
            return (this.validation.isFormDirty || this.validation.isSecondMandatorSurnameDirty)
                && TypeHelper.isNotNullOrUndefined(this.secondMandatorSurnameErrorText);
        },
        mandatorLawformErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.mandator_lawform, validators);
        },
        mandatorPrenameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.mandator_prename, validators);
        },
        mandatorSurnameErrorText()
        {
            let validators = [
                Validation.isNotNull
            ];

            return Validation.runValidation(this.formData.mandator_surname, validators);
        },
        mandatorMailErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isEmail
            ];

            return Validation.runValidation(this.formData.mandator_mail, validators);
        },
        mandatorIbanErrorText()
        {
            let validators = [
                Validation.isNotNull,
                Validation.isIban
            ];

            return Validation.runValidation(this.formData.mandator_iban, validators);
        },
        hasSecondMandatorErrorText()
        {
            let validators = [
                Validation.requiresSelect
            ];

            return Validation.runValidation(this.formData.has_second_mandator, validators);
        },
        secondMandatorLawformErrorText()
        {
            let validators = [];

            if (this.formData.has_second_mandator === true)
                validators.push(Validation.requiresSelect);

            return Validation.runValidation(this.formData.second_mandator_lawform, validators);
        },
        secondMandatorPrenameErrorText()
        {
            let validators = [];

            if (this.formData.has_second_mandator === true)
                validators.push(Validation.isNotNull);

            return Validation.runValidation(this.formData.second_mandator_prename, validators);
        },
        secondMandatorSurnameErrorText()
        {
            let validators = [];

            if (this.formData.has_second_mandator === true)
                validators.push(Validation.isNotNull);

            return Validation.runValidation(this.formData.second_mandator_surname, validators);
        },
    },
    methods: {
        validate()
        {
            this.validation.isFormDirty = true;

            this.emitValidity();
        },
        emitValidity()
        {
            this.$emit('updateValidity', this.isFormValid());
        },
        isFormValid()
        {
            let isValid = true;
            isValid = isValid && (this.mandatorLawformErrorText === null);
            isValid = isValid && (this.mandatorPrenameErrorText === null);
            isValid = isValid && (this.mandatorSurnameErrorText === null);
            isValid = isValid && (this.mandatorMailErrorText === null);
            isValid = isValid && (this.mandatorIbanErrorText === null);
            isValid = isValid && (this.hasSecondMandatorErrorText === null);
            isValid = isValid && (this.secondMandatorLawformErrorText === null);
            isValid = isValid && (this.secondMandatorPrenameErrorText === null);
            isValid = isValid && (this.secondMandatorSurnameErrorText === null);

            return isValid;
        },
        emitChangedData()
        {
            this.$emit('changeCaseData', this.formData);
        }
    },
    watch: {
        'formData.mandator_lawform': function()
        {
            this.validation.isMandatorLawformDirty = true;
        },
        'formData.mandator_prename': function()
        {
            this.validation.isMandatorPrenameDirty = true;
        },
        'formData.mandator_surname': function()
        {
            this.validation.isMandatorSurnameDirty = true;
        },
        'formData.mandator_mail': function()
        {
            this.validation.isMandatorMailDirty = true;
        },
        'formData.mandator_iban': function()
        {
            this.validation.isMandatorIbanDirty = true;
        },
        'formData.has_second_mandator': function()
        {
            this.validation.isHasSecondMandatorDirty = true;
            this.formData.second_mandator_lawform = null;
            this.formData.second_mandator_prename = null;
            this.formData.second_mandator_surname = null;
        },
        'formData.second_mandator_lawform': function()
        {
            this.validation.isSecondMandatorLawformDirty = true;
        },
        'formData.second_mandator_prename': function()
        {
            this.validation.isSecondMandatorPrenameDirty = true;
        },
        'formData.second_mandator_surname': function()
        {
            this.validation.isSecondMandatorSurnameDirty = true;
        },
        formData: {
            handler: function()
            {
                this.emitChangedData();
                this.emitValidity();
            },
            deep: true
        },
    }
};
</script>

<style scoped>
.error label {
    color: #4d4d4d;
}

.sub-borrower-section {
    border: 1px solid #d8d8d8;
    background: #ededed;
    padding: 10px;
    margin-bottom: 10px;
}

select {
    margin: 0 0 1rem;
}

.error select {
    margin-bottom: 0;
}
</style>
